import { graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import tw, { css } from "twin.macro"
import React from "react"
import PreHeader from "../atoms/pre-header"
import FloatingBox from "../atoms/floating-box"
import ContentWrapper from "../atoms/content-wrapper"

const BlockQuote = ({ data }) => (
  <div tw="p-6 relative sm:(px-16) md:(px-20 py-10) lg:px-24 xl:(py-16 px-32)">
    <ContentWrapper tw="text-center xl:relative">
      <FloatingBox
        tw="absolute top-10 left-3 h-4/6 block bg-brand-light_mist w-36 sm:left-8 md:(w-48 left-12) lg:left-16 xl:(top-0 -left-8 h-3/5)"
        css={[
          css`
            @media (min-width: 1280px) {
              width: 306px;
            }
          `,
        ]}
        className="tear-t-sm-mist tear-b-sm-mist"
      />
      <FloatingBox>
        <StaticImage
          src="../../assets/icons/quote_icon.png"
          alt=""
          width={66}
          placeholder="none"
          css={[tw`w-12 h-12 xl:(w-16 h-16)`]}
        />
      </FloatingBox>
      <figure tw="relative py-6 text-left">
        <PreHeader as="figcaption">{data.header}</PreHeader>
        <blockquote
          tw="font-display text-3xl leading-tight tracking-wide sm:text-4xl"
          css={[
            css`
              @media (min-width: 1024px) {
                font-size: 3.25rem;
                line-height: 1.25;
              }
            `,
          ]}
        >
          <div dangerouslySetInnerHTML={{ __html: data.text }}></div>
          <p tw="text-brand-blue">{data.author}</p>
        </blockquote>
      </figure>
    </ContentWrapper>
  </div>
)

export const fragment = graphql`
  fragment BlockQuote on FT_ComponentMoleculesBlockquote {
    header
    author
    text
  }
`

export default BlockQuote
